export default "__VITE_ASSET__CTkPCsS2__"